import React, { useMemo } from "react";
import { ApolloProvider } from "@apollo/client";
import { useAuthState } from "@/modules/auth/useAuthState";
import { createCache } from "./cache";

import getClient from "./getApolloClient";

const cache = createCache().restore(window.__APOLLO_STATE__);
delete window.__APOLLO_STATE__;

const useClient = () => {
  const [{ restHeaders }] = useAuthState();

  const client = useMemo(() => {
    return getClient(restHeaders, {
      cache
    });
  }, [restHeaders]);

  return client;
};

const GraphServiceProvider: React.FC = ({ children }) => {
  const client = useClient();

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default GraphServiceProvider;
